import { AxiosInstance } from "axios";
import Endpoint from "@/utils/endpoint";
import ErrorService from "./erroService";
import ResultResponseInterface from "@/types/app/resultResponse";

export default class NotificationService {


  constructor(private api: AxiosInstance, private endpoint: Endpoint = new Endpoint()) { }



  async saveInfo(eventId:string, title:string, subject:string, body:string): Promise<ResultResponseInterface>{
    try {
      const { data } = await this.api.post(`${this.endpoint.notifications}/set-bodymessage`, 
      {
        eventId,
        title, 
        subject,
        body
      });
      return data;
    } catch (error) {
      
      return ErrorService.onError(error);
    }
  }

  async saveEmailUserInfo(eventId:string, notificationUserId:string, copyEmail: string): Promise<ResultResponseInterface>{
    try {
      const { data } = await this.api.post(`${this.endpoint.notifications}/set-email-user-info`, 
      {
        eventId,
        notificationUserId,
        copyEmail
      });
      return data;
    } catch (error) {
      
      return ErrorService.onError(error);
    }
  }

}